"use client"
import Link from "next/link";
import { usePathname } from "next/navigation";
const OrderNav = () => {
    const pathname = usePathname();
    return (
        <>
            <div className="tabs-container mt-40">
                <ul className="custom-tabs nav">
                    <li>
                        <Link href="/downloads/orders/d-g-o" className={`${pathname === "/downloads/orders/d-g-o" ? "active" : ""} nav-link`}>
                            D G O
                        </Link>
                    </li>
                    <li>
                        <Link href="/downloads/orders/sos-and-proceedings" className={`${pathname === "/downloads/orders/sos-and-proceedings" ? "active" : ""} nav-link`}>
                            SOs And Proceedings
                        </Link>
                    </li>
                    <li>
                        <Link href="/downloads/orders/government-orders" className={`${pathname === "/downloads/orders/government-orders" ? "active" : ""} nav-link`}>
                            Government Orders
                        </Link>
                    </li>
                    <li>
                        <Link  href="/downloads/orders/exam-details" className={`${pathname === "/downloads/orders/exam-details" ? "active" : ""} nav-link`}>
                            Exam Details
                        </Link>
                    </li>

                </ul>
            </div>
        </>
    )
}

export default OrderNav
